export const nothingSelector = () => undefined;
